function mat4ComposeInto(dst, off, tx, ty, tz, qx, qy, qz, qw, sx, sy, sz) {
  const xx = qx * qx, yy = qy * qy, zz = qz * qz;
  const xy = qx * qy, xz = qx * qz, yz = qy * qz;
  const wx = qw * qx, wy = qw * qy, wz = qw * qz;
  dst[off] = (1 - 2 * (yy + zz)) * sx;
  dst[off + 1] = 2 * (xy + wz) * sx;
  dst[off + 2] = 2 * (xz - wy) * sx;
  dst[off + 3] = 0;
  dst[off + 4] = 2 * (xy - wz) * sy;
  dst[off + 5] = (1 - 2 * (xx + zz)) * sy;
  dst[off + 6] = 2 * (yz + wx) * sy;
  dst[off + 7] = 0;
  dst[off + 8] = 2 * (xz + wy) * sz;
  dst[off + 9] = 2 * (yz - wx) * sz;
  dst[off + 10] = (1 - 2 * (xx + yy)) * sz;
  dst[off + 11] = 0;
  dst[off + 12] = tx;
  dst[off + 13] = ty;
  dst[off + 14] = tz;
  dst[off + 15] = 1;
}

export { mat4ComposeInto };
//# sourceMappingURL=mat4-compose-into.js.map
